/**
 * ArtifactPreviewPopover — hover-to-peek popover for Stage 9.
 * Iter87 · initial version; Iter88 · body extracted to
 * <ArtifactPreviewCard /> so the pinned side-panel and the popover
 * stay visually identical.
 */
import { HoverCard, HoverCardTrigger, HoverCardContent } from "@/components/ui/hover-card";
import ArtifactPreviewCard from "./ArtifactPreviewCard";

export default function ArtifactPreviewPopover({ children, preview }) {
  if (!preview || preview.kind === "none") return children;
  return (
    <HoverCard openDelay={220} closeDelay={80}>
      <HoverCardTrigger asChild>{children}</HoverCardTrigger>
      <HoverCardContent
        side="left" align="start"
        className="w-72 p-3"
        data-testid="artifact-preview-popover"
      >
        <ArtifactPreviewCard preview={preview} compact />
        <div className="text-[10px] text-slate-400 pt-2">
          Hover to peek · click 📌 to pin to compare panel
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}
